import { createAction } from '@reduxjs/toolkit';

/**
 * Reset the entire store to initial state
 * Used on logout and auth errors
 */
export const resetStoreAction = createAction('store/reset');
